import { useState, type FormEvent } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { isSupabaseConfigured } from "../lib/supabase";
import { Button } from "../components/ui/Button";
import { ThemeToggle } from "../components/ThemeToggle";

export function AdminLogin() {
  const { user, signIn, loading } = useAuth();
  const location = useLocation();
  const from = (location.state as { from?: { pathname: string } } | null)?.from?.pathname ?? "/admin";

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  if (!loading && user) {
    return <Navigate to={from} replace />;
  }

  const onSubmit = async (event: FormEvent) => {
    event.preventDefault();
    setError(null);
    if (!isSupabaseConfigured) {
      setError("Supabase não está configurado.");
      return;
    }
    setSubmitting(true);
    try {
      await signIn(email, password);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Falha no login.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="relative flex min-h-screen items-center justify-center bg-background px-4">
      <div className="absolute right-4 top-4">
        <ThemeToggle />
      </div>
      <form
        onSubmit={onSubmit}
        className="w-full max-w-sm rounded-2xl border bg-surface p-6 shadow-glow-sm"
      >
        <div className="mb-6 flex items-center gap-2 font-heading text-lg font-semibold text-primary">
          <img src="/icon.png" alt="" width={28} height={28} className="h-7 w-7 rounded-md" />
          Painel admin
        </div>
        <label className="block text-sm text-primary" htmlFor="admin-email">
          Email
        </label>
        <input
          id="admin-email"
          type="email"
          autoComplete="username"
          className="mt-1 w-full rounded-lg border bg-background px-3 py-2.5 text-sm text-primary"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <label className="mt-4 block text-sm text-primary" htmlFor="admin-password">
          Password
        </label>
        <input
          id="admin-password"
          type="password"
          autoComplete="current-password"
          className="mt-1 w-full rounded-lg border bg-background px-3 py-2.5 text-sm text-primary"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        {error && <p className="mt-3 text-sm text-urgent">{error}</p>}
        <Button type="submit" className="mt-6 w-full" disabled={submitting || loading}>
          {submitting ? "A entrar…" : "Entrar"}
        </Button>
      </form>
    </div>
  );
}
